import { PrintableEvent, TableColumn, TableRowDisplayEvent } from "@mcleod/components";
import { CompanySettings } from "@mcleod/core";
import { AutogenLayoutFourKitesControl } from "./autogen/AutogenLayoutFourKitesControl";

export class FourKitesControl extends AutogenLayoutFourKitesControl {

    override async onLoad(): Promise<void> {
        const companyTypeAsset = "A";
        const companyType = CompanySettings.get().company_type;
        if (companyTypeAsset === companyType) {
            const columnExportOverride: TableColumn = this.tableFourKitesControl.columns.find(c => c.headingCell.id === "columnExportOverridePayee");
            const columnExportScac: TableColumn = this.tableFourKitesControl.columns.find(c => c.headingCell.id === "columnScacCode");
            const columnMcNumber: TableColumn = this.tableFourKitesControl.columns.find(c => c.headingCell.id === "columnMCNumber");
            this.tableFourKitesControl.removeColumn(columnExportOverride.headingCell.id);
            this.tableFourKitesControl.removeColumn(columnExportScac.headingCell.id);
            this.tableFourKitesControl.removeColumn(columnMcNumber.headingCell.id);
        }
        this.tableFourKitesControl.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            tableRow.displayComponentValues();
        });
    }


    textboxDeliveredLookbackTimeOnPrintable(event: PrintableEvent) {
        const lookBack = event.target;
        lookBack.fillRow = true;
    }

}
